import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ApDynComponentComponent}                 from '../../../ap-dyncomponent/ap-dyncomponent.component';
import {ApDynGridColumnConfigBase}               from '../../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {ApDynGridPagerConfig}                    from '../../../ap-dyngrids/config/ap-dyn-grid-pager-config';
import {TraceLogActionsStore}                    from '../../../stores/tracelog/actions.store';
import {filter, map}                             from 'rxjs/operators';
import {ApStatsType, IGridData}                  from '../../../ap-interface';
import {ApDynGridPropertyColumnConfig}           from '../../../ap-dyngrids/config/ap-dyn-grid-property-column-config';
import {LanguageStore}                           from '../../../stores/translation/language.store';
import {StatisticStore}                          from '../../../stores/statistic/statistic.store';
import {
  IDatetimeSelectionChartData
}                                                from '../../../ap-interface/interfaces/charts/ap-datetime-selection-chart-data.interface';
import * as moment                               from 'moment';
import IActions = Data.Tracelog.IActions;

interface ITraceLogActionsGridData extends IGridData<IActions> {
}

@Component({
  selector: 'ap-trace-log-actions',
  template: `
    <ap-dyncomponent [columns]="columns"
                     [items]="this.items$ | async"
                     [pager]="pager"
                     [loading$]="traceLogActionsLoading$">
    </ap-dyncomponent>`
})

export class ApTraceLogActionsComponent implements OnInit, OnDestroy {
  @ViewChild(ApDynComponentComponent, {static: true}) dynComponent;

  traceLogActionsLoading$ = this.traceLogActionsStore.Listen(s => s.loading);
  items$ = this.traceLogActionsStore.Listen(s => s.data).pipe(
    filter(d => !!d),
    map(actions => actions.Convert<ITraceLogActionsGridData>((action: IActions) => ({
      Id: action.Id,
      SourceItem: action,
      Data: action.Data ? JSON.stringify(action.Data) : ''
    }))),
  );
  columns: ApDynGridColumnConfigBase[];
  pager: ApDynGridPagerConfig;

  private _list = Array<{ date: string, count: number }>();

  constructor(private traceLogActionsStore: TraceLogActionsStore,
              private languageStore: LanguageStore,
              private statisticStore: StatisticStore) {
  }

  ngOnInit(): void {
    this.statisticStore.removeStatisticData();
    this.traceLogActionsStore.loadTraceLogActions();
    this.gridBuilder();
    this.createStatistic();
  }

  ngOnDestroy(): void {
    this.statisticStore.removeStatisticData();
  }

  createStatistic(): void {
    this.traceLogActionsStore.Listen(s => s.loaded).subscribe(loaded => {
      if (!loaded) {
        return;
      }
      this.traceLogActionsStore.Listen(s => s.data).subscribe(d => {
        if (!d) {
          return;
        }
        if (d.length < 1) {
          return;
        }
        const v = d.GroupBy(e => `${e.DateTime}_${e.FarmId}`);
        const categories = d.GroupBy(e => e.DateTime);
        const cats = Object.keys(categories);
        for (let i = cats.length - 1; i >= 0; --i) {
          this._list.push({
            date: cats[i],
            count: 0
          });
        }
        const z = Object.keys(v);
        z.forEach(i => {
          const a = i.Split('_');
          const found = this._list.Find(_ => _.date === a[0]);
          found.count++;
        });

        const statisticData: Array<IDatetimeSelectionChartData> = [];
        this._list.forEach(l => {
          const item = {
            date: moment(l.date).format('DD.MM.YYYY'),
            count: l.count
          } as IDatetimeSelectionChartData;
          statisticData.push(item);
        });
        this.statisticStore.setStatisticData(statisticData, ApStatsType.DateTimeSelection, 'Betriebe pro Tag');
      });
    });
  }


  gridBuilder(): void {
    this.columns = [
      new ApDynGridPropertyColumnConfig({
        field: 'SourceItem.Id', title: 'Id',
        headerFilterable: true,
        filterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        field: 'SourceItem.FarmId', title: 'FarmId',
        headerFilterable: true,
        filterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        field: 'SourceItem.UserId', title: 'UserId',
        headerFilterable: true,
        filterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        field: 'SourceItem.ClientIp', title: 'ClientIp',
        headerFilterable: true,
        filterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        field: 'SourceItem.Year', title: 'Year',
        headerFilterable: true,
        filterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        field: 'SourceItem.DateTime', title: 'DateTime',
        headerFilterable: true, format: this.languageStore.CurrentDateTimeFormat,
        sortDesc: true, sortIndex: 0,
        filterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        field: 'SourceItem.TimeStamp', title: 'TimeStamp',
        headerFilterable: true, format: this.languageStore.CurrentDateTimeFormat,
        filterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        field: 'SourceItem.Message', title: 'Message',
        headerFilterable: true,
        filterable: true
      }),
      new ApDynGridPropertyColumnConfig({
        field: 'Data', title: 'Data',
        headerFilterable: true,
        filterable: true
      }),
    ];

    this.pager = new ApDynGridPagerConfig();
  }
}
